'use strict';

function DataModel() {
	Object.defineProperty(this, 'sources', {
		writable: true,
		value: [],
	});
	Object.defineProperty(this, 'multiCurrencies', {
		writable: true,
		value: false,
	});
}

DataModel.prototype.find = function (path) {
	var property = null;

	this.sources.some(function (source) {
		if (path.indexOf(source.path) === 0) {
			property = source.find(path);
			if (property) {
				return true;
			}
		} else if (source.path === path) {
			property = source;
			return true;
		}
	});
	return property;
};

DataModel.prototype.addSources = function (sources) {
	sources = sources || [];
	var _this = this;

	sources.forEach(function (source) {
		if (source instanceof DataModelSource) {
			_this.sources.push(source);
		}
	});
};

DataModel.prototype.updateSource = function (source) {
	var index = -1;
	if (source instanceof DataModelSource) {
		this.sources.some(function (s, i) {
			if (s.id === source.id) {
				index = i;
				return true;
			}
		});

		if (index > -1) {
			this.sources[index] = source;
		} else {
			this.sources.push(source);
		}
	}
};

function DataModelSource(options, request, response, forRuntime, specialOptions) {
	options = options || {};
	specialOptions = specialOptions || {};

	if (!(options instanceof mx.SolutionBuilderAgent.DataModelSourceDescriptor)) {
		options = new mx.SolutionBuilderAgent.DataModelSourceDescriptor(options);
	}

	if (!options.Path) {
		throw new Error('No path');
	}

	Object.defineProperty(this, 'FilterExpression', {
		writable: true,
		value: options.FilterExpression || null,
	});
	Object.defineProperty(this, 'allowUnsafeFilter', {
		writable: true,
		value: options.AllowUnsafeFilter || false,
	});

	Object.defineProperty(this, 'id', {
		writable: true,
		value: options.Id || '',
	});
	Object.defineProperty(this, 'name', {
		writable: true,
		value: options.Name || '',
	});
	Object.defineProperty(this, 'path', {
		writable: true,
		value: options.Path,
	});
	Object.defineProperty(this, 'items', {
		writable: true,
		value: options.Items || [],
	});
	Object.defineProperty(this, 'type', {
		writable: true,
		value: options.Type || '',
	});

	if (!forRuntime) {
		Object.defineProperty(this, 'direction', {
			writable: true,
			value: options.Direction,
		});
	}

	if (options.OperationId || options.WorkflowId) {
		Object.defineProperty(this, 'host', {
			writable: true,
			value: options.BaseUrl,
		});
		Object.defineProperty(this, 'service', {
			writable: true,
			value: options.Service || '',
		});
		Object.defineProperty(this, 'serviceId', {
			writable: true,
			value: options.ServiceId || '',
		});
		Object.defineProperty(this, 'operation', {
			writable: true,
			value: options.Operation || '',
		});
		Object.defineProperty(this, 'operationId', {
			writable: true,
			value: options.OperationId || '',
		});
		Object.defineProperty(this, 'relativePath', {
			writable: true,
			value: options.RelativePath || '',
		});
	} else if (options.EntityName || specialOptions.entityName) {
		Object.defineProperty(this, 'entityName', {
			writable: true,
			value: options.EntityName || specialOptions.entityName || '',
		});
	} else if (options.DataDefinition) {
		Object.defineProperty(this, 'dataDefinition', {
			writable: true,
			value: options.DataDefinition || '',
		});
		Object.defineProperty(this, 'filter', {
			writable: true,
			value: options.Filter || '',
		});
	} else if (options.DataQueryId) {
		Object.defineProperty(this, 'dataQueryId', {
			writable: true,
			value: options.DataQueryId || '',
		});
	}

	Object.defineProperty(this, 'httpMethod', {
		writable: true,
		value: mx.shell.HttpMethod.find(options.HttpMethod),
	});
	Object.defineProperty(this, 'reloadable', {
		writable: true,
		value: options.Reloadable === true,
	});
	Object.defineProperty(this, 'refreshInterval', {
		writable: true,
		value: options.RefreshInterval,
	});
	Object.defineProperty(this, 'rewriteResponse', {
		writable: true,
		value: options.RewriteResponse === true,
	});
	Object.defineProperty(this, 'loadOnInit', {
		writable: true,
		value: options.LoadOnInit === true,
	});

	Object.defineProperty(this, 'onSaving', {
		writable: true,
		value: options.OnSaving === true,
	});
	Object.defineProperty(this, 'onSaved', {
		writable: true,
		value: options.OnSaved === true,
	});
	Object.defineProperty(this, 'downloadSource', {
		writable: true,
		value: options.Download === true,
	});

	Object.defineProperty(this, 'hiddenFields', {
		writable: true,
		value: {},
	});
	Object.defineProperty(this, 'isArray', {
		writable: true,
		enumerable: true,
		value: options.IsArray || options.isArray || false,
	});
	Object.defineProperty(this, 'bodyParameter', {
		writable: true,
		value: [],
	});
	Object.defineProperty(this, 'forRuntime', {
		writable: true,
		value: forRuntime === true,
	});

	if (response && response.ContractDescriptor) {
		Object.defineProperty(this, 'multiCurrencies', {
			writable: false,
			value: response.ContractDescriptor.MultiCurrencies || false,
		});
	}
	Object.defineProperty(this, '__options', {
		writable: false,
		enumerable: false,
		value: options,
	});

	this.init(request, response);
}

DataModelSource.prototype.init = function (request, response) {
	// REQUEST
	var contractType = getContractType(request && request.ContractDescriptor);

	if (contractType) {
		this.addPropertiesFromType('RequestContract', request.UsedTypes, mx.SolutionBuilderAgent.DataModelPropertyDirection.IN);
	}
	// RESPONSE
	if (response) {
		contractType = getContractType(response && response.ContractDescriptor);
		if (contractType) {
			this.addPropertiesFromType(contractType, response.UsedTypes, this.direction || mx.SolutionBuilderAgent.DataModelPropertyDirection.OUT);
		}
	}

	function getContractType(contract) {
		var type = null;

		if (contract) {
			if (typeof contract === 'string') {
				type = contract;
			} else if (contract.Type) {
				type = contract.Type || null;
			}
		}
		return type;
	}
};

var sysPropertyDescriptions;

Object.defineProperty(DataModelSource.prototype, 'sysPropertyDescriptions', {
	enumerable: false,
	get: function () {
		if (!sysPropertyDescriptions) {
			var i18n = mx.shell.Injector.get('mx.internationalization');

			var getDescriptionLocalization = function (key) {
				return i18n.get('solutionBuilderAgent.services.dataModel.' + key);
			};

			sysPropertyDescriptions = {
				sourceStateDescription: getDescriptionLocalization('sourceStateDescription'),
				orderByDescription: getDescriptionLocalization('orderByDescription'),
				pageSizeDescription: getDescriptionLocalization('pageSizeDescription'),
				pageNumberDescription: getDescriptionLocalization('pageNumberDescription'),
				totalCountDescription: getDescriptionLocalization('totalCountDescription'),
				filterDescription: getDescriptionLocalization('filterDescription'),
				inactiveDescription: getDescriptionLocalization('inactiveDescription'),
				fragmentIdDescription: getDescriptionLocalization('fragmentIdDescription'),
				shared: getDescriptionLocalization('shared'),
				outerContext: getDescriptionLocalization('outerContextDescription'),
				navigationId: getDescriptionLocalization('navigationIdDescription'),
				filterId: getDescriptionLocalization('filterIdDescription'),
				applicationNameDescription: getDescriptionLocalization('applicationNameDescription'),
				currentUserDescription: getDescriptionLocalization('currentUserDescription'),
				availableOnly: getDescriptionLocalization('availableOnly'),
				actionNameDescription: getDescriptionLocalization('actionNameDescription'),
				actionIdDescription: getDescriptionLocalization('actionIdDescription'),
				actionObjectDescription: getDescriptionLocalization('actionObjectDescription'),
				actionObjectIdDescription: getDescriptionLocalization('actionObjectIdDescription'),
				actionObjectTypeDescription: getDescriptionLocalization('actionObjectTypeDescription'),
				actionObjectDisplayNameDescription: getDescriptionLocalization('actionObjectDisplayNameDescription'),
			};
		}

		return sysPropertyDescriptions;
	},
});

var defaultExpression = 'return $value;';

function MxDataModelItemBase() {}

MxDataModelItemBase.prototype.find = function (path, createPathIfNotExist) {
	if (this.path === path) {
		return this;
	} else if (this.items) {
		var property = null;

		this.items.some(function (childItem) {
			if (property !== null) {
				return true;
			}
			property = childItem.find(path);
		});

		if (!property && createPathIfNotExist && path.indexOf(this.path + '.') === 0) {
			var paths = path.split('.');
			var partPath = paths[0];
			var parent = this;
			for (var i = 1; i < paths.length; i++) {
				var currentPart = paths[i];
				partPath = partPath + '.' + currentPart;

				var parentPath = this.find(partPath);
				if (!parentPath) {
					parent = parent.addProperty(currentPart, {}, { Extended: true }, mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE);
				}
			}
			property = parent;
		}
		return property;
	}
};

MxDataModelItemBase.prototype.addProperty = function (propertyName, options, usedTypes, direction) {
	Object.defineProperty(options, 'ForRuntime', {
		enumerable: false,
		value: this.forRuntime,
	});

	preparePropertyType(options);
	if (options.isODataQueryOptions) {
		propertyName = '$options';
	}

	if (typeof direction === 'undefined') {
		direction = typeof this.direction !== 'undefined' ? this.direction : mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE;
	}

	options.Name = propertyName;
	options.Title = options.Title || propertyName;

	options.Path = this.path + '.' + propertyName;
	options.ParentPath = this.path;
	options.Direction = direction;

	if (this.entityName) {
		options.EntityName = this.entityName;
	}
	if (this.dataDefinition) {
		options.DataDefinition = this.dataDefinition;
	}

	var existedProp = null;
	var property;

	if (
		!this.items.some(function (itm) {
			if (itm.path === options.Path) {
				existedProp = itm;
				return true;
			}
		})
	) {
		property = new mx.SolutionBuilderAgent.DataModelProperty(options);
		if (usedTypes && this.type !== property.type) {
			property.addPropertiesFromType(property.type, usedTypes);
		}

		this.items.push(property);
		var simpleTypes = angular.copy(mx.SolutionBuilderAgent.DataModelTypes);

		delete simpleTypes.MultipleObjectReference;
		delete simpleTypes.Fragment;
		if (property.isArray && simpleTypes.hasOwnProperty(property.type)) {
			var arrayItemOptions = { Title: property.title };

			if (property.type === simpleTypes.ObjectReference && property.referenceTo) {
				arrayItemOptions.ReferenceTo = property.referenceTo;
			}
			property.addSimpleProperty(
				mx.SolutionBuilderAgent.DataModelSystemProperty.Item,
				property.type,
				mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE,
				arrayItemOptions
			);
		}
	} else if (existedProp && !options.ForRuntime) {
		existedProp.expression = options.Expression || defaultExpression;
		existedProp.parameters = options.Parameters;
		existedProp.editMode = options.EditMode;
		existedProp.overridden = true;
	}

	this.bodyParameter = this.bodyParameter || [];
	if (options.Source === mx.SolutionBuilderAgent.SourceParameterType.FromBody) {
		this.bodyParameter.push(propertyName);
	}

	return property || existedProp;

	function preparePropertyType(propertyOptions) {
		var type = propertyOptions.Type;
		var defType = mx.SolutionBuilderAgent.DataModelTypes.ObjectType.name;

		if (typeof type === 'string' && type.indexOf('ODataQueryOptions') !== -1) {
			propertyOptions.isODataQueryOptions = true;
			type = mx.SolutionBuilderAgent.DataModelTypes.StringType.name;
		} else if (Array.isArray(type) || propertyOptions.isArray) {
			propertyOptions.isArray = true;
		} else if (typeof type === 'string' && type.lastIndexOf('[]') === type.length - 2) {
			propertyOptions.isArray = true;
		} else if (Number.isInteger(type)) {
			var typeObj = _.find(mx.SolutionBuilderAgent.DataModelTypes, { id: type });
			if (typeObj) {
				type = typeObj.name;
			} else {
				type = defType;
			}
		}

		if (Array.isArray(type)) {
			type = type.length ? type[0] || defType : defType;
		} else if (typeof type === 'object' && type && type.name) {
			type = type.name;
		}

		if (type) {
			propertyOptions.Type = type;
		} else {
			propertyOptions.Type = defType;
		}
	}
};

MxDataModelItemBase.prototype.addSimpleProperty = function (name, type, direction, options) {
	options = options || {};
	options.Type = type;
	return this.addProperty(name, options, {}, direction);
};

MxDataModelItemBase.prototype.addBoolean = function (name, options) {
	options = options || {};
	return this.addSimpleProperty(name, mx.SolutionBuilderAgent.DataModelTypes.BoolType.name, options.Direction, options);
};

MxDataModelItemBase.prototype.addInt = function (name, options) {
	options = options || {};
	return this.addSimpleProperty(name, mx.SolutionBuilderAgent.DataModelTypes.IntType.name, options.Direction, options);
};

MxDataModelItemBase.prototype.addGuid = function (name, options) {
	options = options || {};
	return this.addSimpleProperty(name, mx.SolutionBuilderAgent.DataModelTypes.GuidType.name, options.Direction, options);
};

MxDataModelItemBase.prototype.addObjectReference = function (name, referenceTo, options) {
	options = options || {};
	options.ReferenceTo = referenceTo || options.ReferenceTo;
	return this.addSimpleProperty(name, mx.SolutionBuilderAgent.DataModelTypes.ObjectReference.name, options.Direction, options);
};

MxDataModelItemBase.prototype.addString = function (name, options) {
	options = options || {};
	return this.addSimpleProperty(name, mx.SolutionBuilderAgent.DataModelTypes.StringType, options.Direction, options);
};

MxDataModelItemBase.prototype.addPropertiesFromType = function (type, usedTypes, direction) {
	var self = this;

	if (type && Array.isArray(type) && type.length) {
		type = type[0] || mx.SolutionBuilderAgent.DataModelTypes.ObjectType.name;
		self.isArray = true;
	}

	self.type = type;

	if (type && usedTypes.hasOwnProperty(type)) {
		var typeDescriptor = usedTypes[type];

		if (typeDescriptor) {
			self.isArray = self.isArray || typeDescriptor.IsArray === true;

			_.forOwn(typeDescriptor.Descriptor, function (propertyDescriptor, propertyName) {
				var prop = self.addProperty(propertyName, propertyDescriptor, usedTypes, direction);

				prop.parentIsArray = self.isArray;
			});
		}
	}
};

DataModelSource.prototype.addSourceState = function () {
	return this.addProperty(
		mx.SolutionBuilderAgent.DataModelSystemProperty.SourceState,
		{
			Type: mx.SolutionBuilderAgent.DataModelTypes.IntType.name,
			Description: this.sysPropertyDescriptions.sourceStateDescription,
		},
		{},
		mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE
	);
};

DataModelSource.prototype.addOrderBy = function (options) {
	return this.addProperty(
		mx.SolutionBuilderAgent.DataModelSystemProperty.OrderBy,
		angular.merge(options || {}, {
			Type: mx.SolutionBuilderAgent.DataModelTypes.StringType.name,
			Description: this.sysPropertyDescriptions.orderByDescription,
		}),
		{},
		mx.SolutionBuilderAgent.DataModelPropertyDirection.IN
	);
};

DataModelSource.prototype.addPagingData = function () {
	var sysProperties = mx.SolutionBuilderAgent.DataModelSystemProperty;
	var direction = mx.SolutionBuilderAgent.DataModelPropertyDirection;

	this.addProperty(
		sysProperties.PageSize,
		{
			Type: mx.SolutionBuilderAgent.DataModelTypes.IntType.name,
			Description: this.sysPropertyDescriptions.pageSizeDescription,
		},
		{},
		direction.IN
	);

	this.addProperty(
		sysProperties.PageNumber,
		{
			Type: mx.SolutionBuilderAgent.DataModelTypes.IntType.name,
			Description: this.sysPropertyDescriptions.pageNumberDescription,
		},
		{},
		direction.IN
	);

	this.addProperty(
		sysProperties.TotalCount,
		{
			Type: mx.SolutionBuilderAgent.DataModelTypes.IntType.name,
			Description: this.sysPropertyDescriptions.totalCountDescription,
		},
		{},
		direction.OUT
	);
};

DataModelSource.prototype.addFilter = function (options) {
	return this.addProperty(
		mx.SolutionBuilderAgent.DataModelSystemProperty.Filter,
		angular.merge(options || {}, {
			Type: mx.SolutionBuilderAgent.DataModelTypes.StringType.name,
			Description: this.sysPropertyDescriptions.filterDescription,
		}),
		{},
		mx.SolutionBuilderAgent.DataModelPropertyDirection.IN
	);
};

DataModelSource.prototype.addInactive = function () {
	return this.addProperty(
		mx.SolutionBuilderAgent.DataModelSystemProperty.Inactive,
		{
			Type: mx.SolutionBuilderAgent.DataModelTypes.BoolType.name,
			Description: this.sysPropertyDescriptions.inactiveDescription,
		},
		{},
		mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE
	);
};

DataModelSource.prototype.addOuterContext = function () {
	return this.addProperty(
		mx.SolutionBuilderAgent.DataModelSystemProperty.OuterContext,
		{
			Type: mx.SolutionBuilderAgent.DataModelTypes.ObjectType.name,
			Description: this.sysPropertyDescriptions.outerContext,
		},
		{},
		mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE
	);
};

DataModelSource.prototype.addSharedContext = function () {
	return this.addProperty(
		mx.SolutionBuilderAgent.DataModelSystemProperty.Shared,
		{
			Type: mx.SolutionBuilderAgent.DataModelTypes.ObjectType.name,
			Description: this.sysPropertyDescriptions.shared,
		},
		{},
		mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE
	);
};

DataModelSource.prototype.addNavigationId = function () {
	return this.addObjectReference('NavigationId', 'PDRNavigationItemClassBase', { Description: this.sysPropertyDescriptions.navigationId });
};

DataModelSource.prototype.addFilterId = function () {
	return this.addObjectReference('FilterId', 'PDRDataQueryClassFilter', { Description: this.sysPropertyDescriptions.filterId });
};

DataModelSource.prototype.addApplicationName = function () {
	return this.addString('ApplicationName', { Description: this.sysPropertyDescriptions.applicationNameDescription });
};

DataModelSource.prototype.addCurrentUser = function () {
	return this.addObjectReference('CurrentUser', 'SPSUserClassBase', { Description: this.sysPropertyDescriptions.currentUserDescription });
};

DataModelSource.prototype.addActionName = function (availableMessage) {
	return this.addString('ActionName', { Description: this.sysPropertyDescriptions.actionNameDescription + availableMessage || '' });
};

DataModelSource.prototype.addActionId = function (availableMessage) {
	return this.addObjectReference('ActionId', 'PDRActionClassBase', { Description: this.sysPropertyDescriptions.actionIdDescription + availableMessage || '' });
};

DataModelSource.prototype.addActionContextObject = function (availableMessage) {
	availableMessage = availableMessage || '';
	var object = this.addSimpleProperty('Object', 'Action Context Object', mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE, {
		Description: this.sysPropertyDescriptions.actionObjectDescription + availableMessage,
	});
	object.addGuid('Id', { Description: this.sysPropertyDescriptions.actionObjectIdDescription + availableMessage });
	object.addString('Type', { Description: this.sysPropertyDescriptions.actionObjectTypeDescription + availableMessage });
	object.addString('DisplayName', { Description: this.sysPropertyDescriptions.actionObjectDisplayNameDescription + availableMessage });
	return object;
};

DataModelSource.prototype.addActionContext = function (isDialog, isWizard) {
	var availableMessage = isDialog ? ' ' + this.sysPropertyDescriptions.availableOnly : '';
	this.addActionName(availableMessage);
	if (isWizard) {
		this.addActionId(availableMessage);
	}
	this.addActionContextObject(availableMessage);
};

function DataModelProperty(options) {
	var that = this;

	options = options || {};

	var id;

	if (options.referenceKey) {
		id = options.referenceKey;
	} else {
		var resKey = options.resourceKey || '';

		if (resKey) {
			var expr = /\[([\w-]+)]/gi;
			var match = expr.exec(resKey);

			id = match !== null ? match[1] : options.id || mx.components.Utils.guid();
		} else {
			id = options.id || mx.components.Utils.guid();
		}
	}

	Object.defineProperty(that, 'id', {
		writable: true,
		enumerable: true,
		value: id,
	});

	Object.defineProperty(that, 'name', {
		writable: true,
		enumerable: true,
		value: options.Name || options.name || '',
	});

	Object.defineProperty(that, 'referenceName', {
		writable: true,
		enumerable: true,
		value: options.ReferenceName || options.referenceName || '',
	});

	Object.defineProperty(that, 'path', {
		writable: true,
		enumerable: true,
		value: options.Path || options.path || that.name,
	});

	Object.defineProperty(that, 'type', {
		writable: true,
		enumerable: true,
		value: options.Type || options.type || null,
	});

	Object.defineProperty(that, 'items', {
		writable: true,
		enumerable: false,
		value: options.items || options.items || [],
	});

	Object.defineProperty(that, 'parentPath', {
		writable: true,
		enumerable: true,
		value: options.ParentPath || options.parentPath,
	});

	Object.defineProperty(that, 'parentItem', {
		writable: true,
		enumerable: false,
		value: options.ParentItem,
	});

	Object.defineProperty(that, 'isArray', {
		writable: true,
		enumerable: true,
		value: options.IsArray || options.isArray,
	});

	Object.defineProperty(that, 'sourceParameterType', {
		writable: true,
		enumerable: true,
		value: options.sourceParameterType || mx.SolutionBuilderAgent.SourceParameterType.Unknown,
	});

	Object.defineProperty(that, 'direction', {
		writable: true,
		enumerable: true,
		value: options.Direction || options.direction || mx.SolutionBuilderAgent.DataModelPropertyDirection.NONE,
	});

	if (!options.ForRuntime) {
		if (options.EntityName) {
			Object.defineProperty(this, 'entityName', {
				writable: true,
				value: options.EntityName || '',
			});
		}

		if (options.DataDefinition) {
			Object.defineProperty(this, 'dataDefinition', {
				writable: true,
				value: options.DataDefinition || '',
			});
			Object.defineProperty(this, 'filter', {
				writable: true,
				value: options.Filter || '',
			});
		}

		Object.defineProperty(that, '__type', {
			writable: true,
			enumerable: true,
			value: mx.SolutionBuilderAgent.TemplatePropertyValueTypes.model.id,
		});

		Object.defineProperty(that, 'resourceKey', {
			writable: true,
			enumerable: false,
			value: options.ResourceKey || options.resourceKey,
		});

		var expression = typeof options.Expression !== 'undefined' || typeof options.expression !== 'undefined' ? options.Expression || options.expression : defaultExpression;

		Object.defineProperty(that, 'expression', {
			writable: true,
			enumerable: false,
			value: expression,
		});

		Object.defineProperty(that, 'typeTitle', {
			writable: true,
			enumerable: false,
			value: that.type && typeof that.type === 'string' ? that.type.replace('Type', '') : null,
		});

		Object.defineProperty(that, 'referenceTo', {
			writable: true,
			enumerable: true,
			value: options.ReferenceTo || options.referenceTo,
		});

		Object.defineProperty(that, 'displayName', {
			writable: true,
			enumerable: false,
			value: options.Title || options.Name,
		});

		Object.defineProperty(that, 'description', {
			writable: true,
			enumerable: false,
			value: options.Documentation || options.Description || options.description || '',
		});

		Object.defineProperty(that, 'parameters', {
			writable: true,
			enumerable: false,
			value: options.Parameters || options.parameters || [],
		});

		Object.defineProperty(that, 'editMode', {
			writable: true,
			enumerable: false,
			value: options.EditMode || options.editMode || 0,
		});

		Object.defineProperty(that, 'parentIsArray', {
			writable: true,
			enumerable: false,
			value: options.ParentIsArray || options.parentIsArray || false,
		});

		Object.defineProperty(that, 'required', {
			writable: true,
			enumerable: true,
			value: options.Required || options.required,
		});
		Object.defineProperty(that, 'maxLength', {
			writable: true,
			enumerable: true,
			value: options.MaxLength || options.maxLength,
		});
		Object.defineProperty(that, 'extended', {
			writable: true,
			enumerable: true,
			value: options.Extended || options.extended,
		});
		Object.defineProperty(that, 'added', {
			writable: true,
			enumerable: true,
			value: options.Added || options.added,
		});

		if (that.referenceTo) {
			Object.defineProperty(that, 'relationsConfig', {
				enumerable: true,
				value: new mx.SolutionBuilderAgent.RelationsConfig(options),
			});
		}
	}
}

angular.extend(DataModelSource.prototype, MxDataModelItemBase.prototype);
angular.extend(DataModelProperty.prototype, MxDataModelItemBase.prototype);

DataModelProperty.prototype.toString = function (shortMode) {
	return '[' + (shortMode ? this.displayName : this.path) + ']';
};

DataModelProperty.prototype.toJSON = function () {
	return {
		__type: mx.SolutionBuilderAgent.TemplatePropertyValueTypes.model.id,
		path: this.path,
	};
};

export { DataModel, DataModelSource, DataModelProperty };
